import { Select, Space, Typography } from 'antd';
import { FC } from 'react';

import { ReasonOptions } from '../typings/reasonOptions';

interface SelectReasonProps {
  description: string;
  confirmationAsk: string;
  handleChange: (value: number) => void;
  options?: ReasonOptions[];
  loading?: boolean;
}
const { Text } = Typography;

export const SelectReason: FC<SelectReasonProps> = ({
  description,
  confirmationAsk,
  handleChange,
  options,
  loading,
}) => {
  const formattedOptions = options?.map(option => ({
    label: option.description,
    value: option.id,
  }));
  return (
    <Space direction='vertical' style={{ width: '100%' }}>
      <Text style={{ marginTop: '16px' }}>{description}</Text>
      <Select
        placeholder='Selecionar motivo...'
        options={formattedOptions}
        onChange={handleChange}
        style={{ width: '100%', margin: '16px 0px' }}
        loading={loading}
      />
      <Text>{confirmationAsk}</Text>
    </Space>
  );
};
